import Page from '../components/ui/Page';
import { useMediaQuery } from 'react-responsive';

import SampleTimeline from '../components/SampleTimeline';
import ContentLayout from '../layouts/ContentLayout';
import { addDays } from '../utils/date';
import defaultSample from '../utils/examples/default';

const IndexPage = () => {
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
  const scale = isTabletOrMobile ? '1.2' : '1.25';
  const translateX = isTabletOrMobile ? '10vw' : '15vw';
  return (
    <Page>
      <ContentLayout
        fullWidth
        logoOnly={false}
        showCTA
        heading="Shareable roadmaps for your teams."
      >
        <div className="w-full mt-8">
          <div className="overflow-hidden">
            <div
              className="top-0 mt-16 mb-32"
              style={{
                perspective: '1000px',
                perspectiveOrigin: '20% 30%',
                transform: `scale(${scale})`,
                transformOrigin: 'top',
              }}
            >
              <div style={{ transform: `rotateY(25deg) translate3d(${translateX}, 0px, 0)` }}>
                <SampleTimeline
                  timeline={defaultSample}
                  initialAnchorDate={isTabletOrMobile ? new Date() : addDays(new Date(), 4)}
                />
              </div>
            </div>
          </div>
        </div>
      </ContentLayout>
    </Page>
  );
};

export default IndexPage;
